export default function initdrawer() {
    const $drawerContainers = document.querySelectorAll<HTMLElement>('.js-drawer-container');
    $drawerContainers.forEach($container => {
        new drawer($container);
    });
}

/**
 * Rend un menu en tiroir
 * 
 * Utilisation :
 * <div class="js-drawer-big-wrapper" >
 *  <button class="js-drawer-back-button"
 *   <button class="js-drawer-button">Toggle menu</button>
 *   <div class="js-drawer-content">
 *   </div>
 * <div class="js-drawer-buttons"></div>
 * </div>
 */
export class drawer {

    $container: HTMLElement | null | undefined;
    $button: HTMLElement | null | undefined;
    $content: HTMLElement | null | undefined;
    $bigContainer: HTMLElement | null | undefined;
    $allContainers: NodeListOf<Element> | null | undefined;
    $getBackButton: HTMLElement | null | undefined;
    $buttonsBox: HTMLElement | null | undefined;

    constructor($container: HTMLElement | null) {
        this.$container = $container;
        this.$button = $container?.querySelector('.js-drawer-button');
        this.$content = $container?.querySelector('.js-drawer-content');
        this.$bigContainer = this.$container?.closest('.js-drawer-big-wrapper');
        this.$allContainers = this.$bigContainer?.querySelectorAll('.js-drawer-container');
        this.$getBackButton = this.$bigContainer?.querySelector('.js-drawer-back-button');
        this.$buttonsBox = this.$bigContainer?.querySelector('.js-drawer-buttons');

        this.init();
    }

    /**
     * Initialise les éléments du drawer
     *
     * @return {void}
     */
    init() {
        this.$button?.addEventListener('click', () => {
            this.openDrawer();
        });
        this.$getBackButton?.addEventListener('click', () => {
            this.closeDrawer();
        })

        document.addEventListener('modalclose', (evt) => {
            const allDrawers = evt.detail.querySelectorAll('.js-drawer-container');
            allDrawers.forEach(() => this.closeDrawer())
        });
    }

    /**
     * Ouvre le drawer
     *
     * @return {void}
     */
    openDrawer() {
        this.$container?.classList.add('active');
        this.$getBackButton?.classList.add('active');
        this.$button?.classList.add('hidden');
        this.$buttonsBox?.classList.add('hidden');
        this.$allContainers?.forEach((container) => {
            if (!container.classList.contains('active')){
                container.classList.add('hidden');
            }
        })
    }

    /**
     * fermer le drawer
     *
     * @return {void}
     */
    closeDrawer() {
        this.$container?.classList.remove('active');
        this.$getBackButton?.classList.remove('active');
        this.$button?.classList.remove('hidden');
        this.$buttonsBox?.classList.remove('hidden');
        this.$allContainers?.forEach((container) => {
            if (!container.classList.contains('active')){
                container.classList.remove('hidden');
            }
        })
    }
}

